/**
 * Round a value to have a given number of decimals
 * @param value - number value
 * @param decimals - number of decimals
 */
export const round = (value: number, decimals: number) => {
    return Number(Math.round(Number(value + "e" + decimals)) + "e-" + decimals).toFixed(decimals);
};

/**
 * Get number with leading 0
 * @param value - the number to transform
 */
export const getWithLeadingZero = (value: number) => {
    return value > 9
        ? String(value)
        : "0" + value;
};

/**
 * Format bytes to readable string
 * @param bytes
 * @param decimals
 */
export const formatBytes = (bytes: number, decimals = 2) => {
    bytes = Number(bytes);

    if (isNaN(bytes)) return "";

    if (!bytes) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

/**
 * Get milliseconds formatted as HH:MM:SS
 * @param duration - duration in milliseconds
 */
export const msToTime = (duration: number) => {
    duration = Number(duration);

    if (isNaN(duration)) return "";

    const seconds = Math.floor((duration / 1000) % 60);
    const minutes = Math.floor((duration / (1000 * 60)) % 60);
    const hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

    return getWithLeadingZero(hours) + ":" + getWithLeadingZero(minutes) + ":" + getWithLeadingZero(seconds);
  };


